import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './views/login/login.component';
import { ReviewComponent } from './views/review/review.component';
import { ErrorComponent } from './views/error/error.component';
import { SuccessComponent } from './views/success/success.component';
import { ProcessingComponent } from './views/processing/processing.component';
import { OneUpgradeLayoutComponent } from './views/layout/layout.component';
import {
  OneUpgradeGuard,
  LoginGuard,
  PNRGuard,
  SinglePaxGuard,
  SuccessGuard,
  ProcessingGuard,
  RefetchGuard,
  BasketGuard,
} from './guards/index';
import { LoadingComponent } from './views/loading/loading.component';
import { PassengersSelectionComponent } from './views/passengers-selection/passengers-selection.component';
import { FlightsSelectionComponent } from './views/flights-selection/flights-selection.component';
import { Stage } from './interfaces';

export const oneUpgradeRoutes: Routes = [
  {
    path: '',
    component: OneUpgradeLayoutComponent,
    canActivateChild: [OneUpgradeGuard],
    children: [
      {
        path: Stage.LOGIN,
        canActivate: [LoginGuard],
        component: LoginComponent,
      },
      {
        path: Stage.LOADING,
        canActivate: [PNRGuard],
        component: LoadingComponent,
      },
      {
        path: Stage.PASSENGERS,
        canActivate: [PNRGuard, SinglePaxGuard, RefetchGuard],
        component: PassengersSelectionComponent,
      },
      {
        path: Stage.FLIGHTS,
        canActivate: [PNRGuard, RefetchGuard],
        component: FlightsSelectionComponent,
      },
      {
        path: Stage.REVIEW,
        canActivate: [RefetchGuard, BasketGuard],
        component: ReviewComponent,
      },
      {
        path: Stage.ERROR,
        component: ErrorComponent,
      },
      {
        path: Stage.SUCCESS,
        canActivate: [SuccessGuard],
        component: SuccessComponent,
      },
      {
        path: Stage.PROCESSING,
        component: ProcessingComponent,
        canActivate: [ProcessingGuard],
      },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(oneUpgradeRoutes)],
  declarations: [],
  exports: [RouterModule],
})
export class OneUpgradeRouteModule {}
